import moment from 'moment';

angular.module('am4')
.controller('upsertNCEquipmentCtrl', function($stateParams, $rootScope, $scope, equipment, organization_id, nonconnectedMachineService, errorService, ngDialog) {
    var that = this;
    that.type = $stateParams.equipment_id ? 'EDIT' : 'NEW';

    that.brandOptions = [
        'Matrix Fitness',
        'Vision',
        'Horizon',
        'Tempo',
        'AFG',
        'Ziva',
        'Cybex',
        'Dynamic',
        'EGym',
        'FreeMotion',
        'Hammer Strength',
        'Hoist',
        'Legend',
        'LifeFitness',
        'Lifespan',
        'Nautilus',
        'NordicTrack',
        'Octane',
        'Precor',
        'Stairmaster',
        'Star Trac',
        'TechnoGym',
        'True Fitness',
        'Tuff Stuff',
        'VersaClimber',
        'Woodway'
    ];

    that.typeOptions = [
        'treadmill',
        'elliptical',
        'ascent',
        'climbmill',
        'stepper',
        'bike_upright',
        'bike_recumbent',
        'bike_hybrid',
        'rower',
        'krankcycle',
        'connexus',
        'intrinity',
        'strength_single_station',
        'strength_multi_station',
        'strength_free_weights',
        'strength_plate_loaded',
        'strength_racks_platforms',
        'strength_accessories',
        'strength_components',
        'strength_other',
        'other'
    ];

    that.equipment = equipment;
    that.serials = equipment.serialNumber && equipment.serialNumber.length ? equipment.serialNumber : [
        {
            value: '',
            description: ''
        }
    ];

    that.SKUs = equipment.SKU && equipment.SKU.length ? equipment.SKU : [
        {
            value: ''
        }
    ];

    that.addInputField = function(type) {
        var obj = type === 'serials' ? { value: '', description: '' } : { value: '' };
        that[type].push(obj);
    };

    that.removeInputField = function(type, i) {
        that[type].splice(i, 1);
    };

    that.submit = function() {

        $scope.isSaving = true;

        that.equipment.modality = that.equipment.machine_type_code;
        that.equipment.active = true;
        that.equipment.am_enabled = false;
        that.equipment.facility_id = +$stateParams.id;
        that.equipment.organization_id = organization_id;
        that.equipment.serialNumber = that.serials.filter(function(serialObj) { return serialObj.value && serialObj.description; });
        that.equipment.SKU = that.SKUs.filter(function(skuObj) { return skuObj.value; });
        that.equipment.time_zone = 'GMT';
        that.equipment.discovery_date = that.equipment.discovery_date || moment.utc().format('YYYY-MM-DD HH:mm:ss');
        that.equipment.updated_at = moment.utc().format('YYYY-MM-DD HH:mm:ss');

        var APIPromise = that.type === 'NEW' ?
            nonconnectedMachineService.postNonconnectedMachine.bind(null, that.equipment) :
            nonconnectedMachineService.putNonconnectedMachine.bind(null, that.equipment, that.equipment.id);

        return APIPromise()
        .then(function() {
            $rootScope.$broadcast('nonconnectedEquipment:update');
        })
        .catch(function(e) {
            errorService.addError('ERROR_UPLOADING_NONCONNECTED_EQUIPMENT', e);
        })
        .finally(function() {
            $scope.isSaving = false;
            $scope.closeThisDialog();
        });
    };

    that.delete = function() {
        $scope.deleting = true;
        return nonconnectedMachineService.deleteNonconnectedMachine(+$stateParams.equipment_id, +$stateParams.id)
        .then(function() {
            $rootScope.$broadcast('nonconnectedEquipment:update');
        })
        .catch(function(e) {
            errorService.addError('ERROR_DELETING_NONCONNECTED_EQUIPMENT', e);
        })
        .finally(function() {
            $scope.deleting = false;
            $scope.closeThisDialog();
        });
    };

    that.requestService = function() {

        ngDialog.open({
            template: require('../views/modal/serviceRequest.html'),
            plain: true,
            controller: 'serviceRequestCtrl as serviceRequestCtrl',
            resolve: {
                machineData: function() { return that.equipment; },
                type: function() { return 'nonconnected'; },
                nonconnected_id: function() { return $stateParams.equipment_id; }
            }
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/upsertNCEquipmentCtrl.js